$(document).ready(function() {
    if ($("#modal-promociones").length) {
        $("#modal-promociones").modal("show");

        $("#cerrar-modal-promocion").click(function() {
            $("#modal-promociones").modal("hide");
        });
    }

    if ($("#pegote-promocion").length) {
        $("#pegote-promocion").on("click", function(e) {
            e.preventDefault();
            $("#modal-promociones").modal("show");
        });
    }
});
